"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Resolver = void 0;
class Resolver {
    constructor(defaultValues) {
        this.defaultValues = defaultValues !== null && defaultValues !== void 0 ? defaultValues : {};
    }
    resolve(message, values) {
        let resolvedMessage = message;
        const finalValues = Object.assign(Object.assign({}, this.defaultValues), values);
        [...Object.keys(finalValues)].forEach(key => {
            resolvedMessage = this.resolveCriteria(resolvedMessage, key, finalValues[key]);
        });
        return resolvedMessage;
    }
}
exports.Resolver = Resolver;
//# sourceMappingURL=resolver.js.map